import { cx, css } from '@lastbrand/web-ui-styled-system/css'
import { useTranslation } from 'next-i18next'
import React from 'react'

import { getCutoffTime } from '@src/quince-site-common/src/hooks/edd/utils/edd.utils'

const orderCutoffTimeClass = css({
  color: 'mediumgray',
  textStyle: 'body-14',
  fontFeatureSettings: "'liga' off, 'clig' off",
})

interface OrderCutoffTimeDSProps {
  cutoffDate: number
  className?: string
}

/**
 * DS twin of the legacy OrderCutoffTime. Reuses getCutoffTime verbatim and the
 * same 'edd' i18n keyprefix. Renders nothing once the cutoff has expired.
 */
export function OrderCutoffTimeDS({ cutoffDate, className }: OrderCutoffTimeDSProps) {
  const { t } = useTranslation('common', { keyPrefix: 'edd' })

  const label = getCutoffTime(cutoffDate, t)

  if (!label) {
    return null
  }

  return (
    <div data-testid="order-cutoff-time" className={cx(orderCutoffTimeClass, className)}>
      {label}
    </div>
  )
}

export default OrderCutoffTimeDS
